(function () {
  "use strict";

  angular
    .module('trainerWebApp.services')
    .factory('xlsConsts', xlsConsts);

  function xlsConsts() {
    var _emailFieldId = 'email';
    var _firstFieldId = 'firstName';
    var _lastFieldId = 'lastName';
    var _usernameFieldId = 'username';
    var _passwordFieldId = 'password';

    var _mfFields = [
      {name: 'First Name', id: _firstFieldId, columnIdx: null},
      {name: 'Last Name', id: _lastFieldId, columnIdx: null},
      {name: 'Email', id: _emailFieldId, columnIdx: null},
      {name: 'Username', id: _usernameFieldId, columnIdx: null},
      {name: 'Password', id: _passwordFieldId, columnIdx: null}
    ];
    var _firstNameIdx = 0;
    var _lastNameIdx = 1;
    var _emailIdx = 2;
    var _usernameIdx = 3;
    var _passwordIdx = 4;

    return {
      getMfFields: function (isUsernameEnabled) {
        //If we want to return a new set each time, it has to be a func
        var result = _.map(_mfFields, function (field) {
          return _.clone(field);
        });

        if (!isUsernameEnabled) {
          result = _.reject(result, function (el) {
            return el.name === _mfFields[_usernameIdx].name ||
              el.name === _mfFields[_passwordIdx].name;
          });
        }
        return result;
      },
      firstNameIdx: _firstNameIdx,
      lastNameIdx: _lastNameIdx,
      emailIdx: _emailIdx,
      usernameIdx: _usernameIdx,
      passwordIdx: _passwordIdx,
      emailFieldId: _emailFieldId,
      firstFieldId: _firstFieldId,
      lastFieldId: _lastFieldId,
      usernameFieldId: _usernameFieldId,
      passwordFieldId: _passwordFieldId
    };
  }

})();
